<!-- =================================================
 Vue Template
================================================== -->
<template>
  <div class="website">
    <div class="row landing-design">
      <div class="hidden-md col-12" style="text-align:center">
        <img :src="landing_web" style="width:90%">
      </div>
      <div class="hidden-xs col-md-1"></div>
      <div class="col-12 col-md-5" style="padding-top:80px">
        <h1 class="title-landing">From simple landing page to complex Web apps.</h1>
        <h1 class="subtitle-landing">Marketplace, secure online payments, management and admin dashboards, chat bots, </h1>
        <button onclick="smoothScroll(document.getElementById('landing-2'))" class="button-landing-discover">Discover our features</button>
      </div>
      <div class="hidden-xs col-md-6" style="text-align:center">
        <img :src="landing_web" style="width:90%">
      </div>
    </div>

    <div id="landing-2" class="row row-1 ligne-discover" style="padding-top:80px;">
      <div class="col-md-1"></div>
      <div class="col-md-3 hidden-xs" style="text-align:center">
        <img :src="layouts" style="width:80%;padding-top:15px;">
      </div>
      <div class="col-md-7">
        <h1 class="title-landing-2">Choose the layouts.</h1>
        <div class="hidden-md" style="text-align:center"><img :src="layouts" style="width:80%;padding-top:15px;"></div>
        <h1 class="subtitle-landing-2">Organise the web app however you want. </h1>
      </div>
      <div class="col-md-1"></div>
    </div>

    <div id="landing-2" class="row row-1 ligne-discover">
      <div class="col-md-1"></div>
      <div class="col-md-7">
        <h1 class="title-landing-2">Secure your payments.</h1>
        <div class="hidden-md" style="text-align:center"><img :src="cb" style="width:80%;padding-top:15px;"></div>
        <h1 class="subtitle-landing-2">We provide secure online payments in 2 clicks for your users. </h1>
      </div>
      <div class="col-md-3 hidden-xs" style="text-align:center">
        <img :src="cb" style="width:80%;padding-top:15px;">
      </div>
      <div class="col-md-1"></div>
    </div>


    <div id="landing-2" class="row row-1 ligne-discover">
      <div class="col-md-1"></div>
      <div class="col-md-3 hidden-xs" style="text-align:center">
        <img :src="chat" style="width:70%;padding-top:15px;">
      </div>
      <div class="col-md-7">
        <h1 class="title-landing-2">Chat with your users.</h1>
        <div class="hidden-md" style="text-align:center"><img :src="chat" style="width:80%;padding-top:15px;"></div>
        <h1 class="subtitle-landing-2">Communication is key. We provide instant messaging chat bots in order to satify your curstomers in seconds without any efforts.</h1>
      </div>
      <div class="col-md-1"></div>
    </div>

    <div id="landing-2" class="row row-1 ligne-discover">
      <div class="col-md-1"></div>
      <div class="col-md-7">
        <h1 class="title-landing-2">Manage your data.</h1>
        <div class="hidden-md" style="text-align:center"><img :src="data" style="width:80%;padding-top:15px;"></div>
        <h1 class="subtitle-landing-2">We provide beautiful admin dashboards in order to manage your data, visualize your sales, your user actions and your profits. </h1>
        <div class="row row-1">
          <div class="col-2 col-md-4"></div>
          <div class="col-8 col-md-4">
            <router-link to="/api" class="router-api"><button class="button-landing-api">More...</button></router-link>
          </div>
          <div class="col-2 col-md-4"></div>
        </div>
      </div>
      <div class="col-md-3 hidden-xs" style="text-align:center;padding-top:25px;">
        <img :src="data" style="width:80%;padding-top:15px;border: 0.7px solid rgb(105, 170, 245);border-radius:6px;">
      </div>
      <div class="col-md-1"></div>
    </div>


  </div>
</template>

<!-- =================================================

        Discover Twill<br>
        We combine the best technologies to make your users happy to use your product.<br>
        vue JS + Firebase + Sketch

 Vue Script
================================================== -->
<script>
export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    wave: require('./assets/img/app/wave.svg'),
    app_twill: require('./assets/img/app/app_twill.png'),
    landing_web: require('./assets/img/website/landing_web.png'),
    layouts: require('./assets/img/website/web_landing.svg'),
    vue: require('./assets/img/discover/vue.png'),
    cb: require('./assets/img/website/cb.png'),
    chat: require('./assets/img/website/chat.svg'),
    data: require('./assets/img/data/data.jpg'),


    firebase: require('./assets/img/discover/firebase.png'),
    sketch: require('./assets/img/discover/sketch.png'),
    hr: require('./assets/img/discover/hr.svg'),
    show_contact_form: this.$parent.show_contact_form,
    tick: require('./assets/img/price/tick.svg')
  }
  },
    methods: {
      data_to_app: function data_to_app() {
        this.$emit('openContact');
        console.log('yesssss');
      }
  }
}

window.smoothScroll = function(target) {
    var scrollContainer = target;
    do { //find scroll container
        scrollContainer = scrollContainer.parentNode;
        if (!scrollContainer) return;
        scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    var targetY = 0;
    do { //find the top of target relatively to the container
        if (target == scrollContainer) break;
        targetY += target.offsetTop;
    } while (target = target.offsetParent);

    scroll = function(c, a, b, i) {
        i++; if (i > 30) return;
        c.scrollTop = a + (b - a) / 30 * i;
        setTimeout(function(){ scroll(c, a, b, i); }, 10);
    }
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
}

</script>

<!-- =================================================
 Vue Style
================================================== -->
<style scoped>

.router-api{
  text-align:center;

}

.button-landing-discover{
  margin-top:20px;
  background-color:rgb(105, 170, 245);
  border-radius:4px;
  color:white;
  height: 40px;
  width:200px;
  margin-bottom:20px;
}

.button-landing-discover:hover{
  cursor: pointer;
  background-color:rgb(134, 190, 250);
}

.button-landing-api{
  margin-top:20px;
  background-color:rgb(105, 170, 245);
  border-radius:4px;
  color:white;
  height: 40px;
  width:200px;
  margin-bottom:20px;

}

.button-landing-api:hover{
  cursor: pointer;
  background-color:rgb(134, 190, 250);
}

/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}

.landing-design{
  height:auto;
  width:100%;
  margin-left:0px;
  padding-top:70px;
  position: relative;
  z-index:10px;
background-color:#26A69A;
}
.ligne-discover{
  background-color:white;
  height:auto;
  padding-top:30px;
  margin-top: -5px;
}
}


/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}

.landing-design{
  height:100vh;
  width:100%;
  margin-left:0px;
  padding-top:150px;
  position: relative;
  z-index:10px;
background-color:#26A69A;
}
.ligne-discover{
  background-color:white;
  height:auto;
  padding-top:30px;
  margin-top: -5px;
}
}

.title-landing-2{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(87, 87, 87);
font-size:34px;
font-weight:normal;  
text-align:center;
padding-top:50px;
}

.subtitle-landing-2{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(129, 129, 129);
font-size:25px;
font-weight:normal;  
margin-bottom:30px;
text-align: justify;
text-align:center;
padding-top:7px;
line-height: 1.4;
}

.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
font-weight:normal;
}
.subtitle-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(201, 198, 198);
font-size:30px;
font-weight:normal;  
}
.row-1{
  width:100%;
  margin-left:0;
}
</style>


// WEBPACK FOOTER //
// src/website.vue